module.exports = __webpack_public_path__ + "img/BOTANAS.8e4538ac.png";